import api from '../api/advertisementsApi';
import { actions as notifications } from './notificationActions';
import * as logger from '../utils/logger';

export const types = {
  LOAD_ADVERTISEMENTS: 'LOAD_ADVERTISEMENTS',
  LOAD_ADVERTISEMENTS_SUCCESS: 'LOAD_ADVERTISEMENTS_SUCCESS',
  LOAD_ADVERTISEMENTS_FAILURE: 'LOAD_ADVERTISEMENTS_FAILURE',
  GET_ADVERTISEMENT: 'GET_ADVERTISEMENT',
  GET_ADVERTISEMENT_SUCCESS: 'GET_ADVERTISEMENT_SUCCESS',
  GET_ADVERTISEMENT_FAILURE: 'GET_ADVERTISEMENT_FAILURE',
  CREATE_ADVERTISEMENT: 'CREATE_ADVERTISEMENT',
  CREATE_ADVERTISEMENT_SUCCESS: 'CREATE_ADVERTISEMENT_SUCCESS',
  CREATE_ADVERTISEMENT_FAILURE: 'CREATE_ADVERTISEMENT_FAILURE',
  UPDATE_ADVERTISEMENT: 'UPDATE_ADVERTISEMENT',
  UPDATE_ADVERTISEMENT_SUCCESS: 'UPDATE_ADVERTISEMENT_SUCCESS',
  UPDATE_ADVERTISEMENT_FAILURE: 'UPDATE_ADVERTISEMENT_FAILURE',
  PUBLISH_ADVERTISEMENT: 'PUBLISH_ADVERTISEMENT',
  PUBLISH_ADVERTISEMENT_SUCCESS: 'PUBLISH_ADVERTISEMENT_SUCCESS',
  PUBLISH_ADVERTISEMENT_FAILURE: 'PUBLISH_ADVERTISEMENT_FAILURE',
  DELETE_ADVERTISEMENT: 'DELETE_ADVERTISEMENT',
  DELETE_ADVERTISEMENT_SUCCESS: 'DELETE_ADVERTISEMENT_SUCCESS',
  DELETE_ADVERTISEMENT_FAILURE: 'DELETE_ADVERTISEMENT_FAILURE',
};

export const actions = {
  load: (pageNumber, pageSize, sortBy, filterBy) => dispatch => {
    dispatch({ type: types.LOAD_ADVERTISEMENTS, pageNumber, pageSize, sortBy, filterBy });
    return api.list(pageNumber, pageSize, sortBy, filterBy).then(res => {
      if (res.ok) {
        dispatch({ type: types.LOAD_ADVERTISEMENTS_SUCCESS, result: res.data || {} });
      } else {
        dispatch({ type: types.LOAD_ADVERTISEMENTS_FAILURE });
        dispatch(notifications.showError('Wystąpił problem podczas pobierania reklam'));
        logger.error(res.data);
      }
    }).catch(error => {
      dispatch({ type: types.LOAD_ADVERTISEMENTS_FAILURE });
      dispatch(notifications.showError('Wystąpił problem podczas pobierania reklam'));
      logger.error(error);
    });
  },

  getDetails: id => async dispatch => {
    dispatch({ type: types.GET_ADVERTISEMENT });
    try {
      const response = await api.getDetails(id);
      if (!response.ok || (response.data && response.data.success === false)) {
        dispatch({ type: types.GET_ADVERTISEMENT_FAILURE });
        dispatch(notifications.showError('Wystąpił problem podczas pobierania szczegółów reklamy'));
        logger.error(response.data);
        return { success: false };
      }
      dispatch({ type: types.GET_ADVERTISEMENT_SUCCESS, data: response.data });
      return { success: true, data: response.data };
    } catch (error) {
      dispatch({ type: types.GET_ADVERTISEMENT_FAILURE });
      dispatch(notifications.showError('Wystąpił problem podczas pobierania szczegółów reklamy'));
      logger.error(error);
      return { success: false };
    }
  },
  
  create: values => async dispatch => {
    dispatch({ type: types.CREATE_ADVERTISEMENT });
    try {
      const response = await api.create(values);
      if (!response.ok || (response.data && response.data.success === false)) {
        dispatch({ type: types.CREATE_ADVERTISEMENT_FAILURE });
        dispatch(notifications.showError('Wystąpił problem podczas tworzenia reklamy'));
        logger.error(response.data);
        return { success: false };
      }
      dispatch({ type: types.CREATE_ADVERTISEMENT_SUCCESS, data: response.data });
      dispatch(notifications.showSuccess('Utworzono reklamę'));
      return { success: true, data: response.data };
    } catch (error) {
      dispatch({ type: types.CREATE_ADVERTISEMENT_FAILURE });
      dispatch(notifications.showError('Wystąpił problem podczas tworzenia reklamy'));
      logger.error(error);
      return { success: false };
    }
  },

  update: (id, values) => async dispatch => {
    dispatch({ type: types.UPDATE_ADVERTISEMENT });
    try {
      const response = await api.update(id, values);
      if (!response.ok || (response.data && response.data.success === false)) {
        dispatch({ type: types.UPDATE_ADVERTISEMENT_FAILURE });
        dispatch(notifications.showError('Wystąpił problem podczas aktualizacji reklamy'));
        logger.error(response.data);
        return { success: false };
      }
      dispatch({ type: types.UPDATE_ADVERTISEMENT_SUCCESS, data: response.data });
      dispatch(notifications.showSuccess('Zapisano reklamę'));
      return { success: true, data: response.data };
    } catch (error) {
      dispatch({ type: types.UPDATE_ADVERTISEMENT_FAILURE });
      dispatch(notifications.showError('Wystąpił problem podczas aktualizacji reklamy'));
      logger.error(error);
      return { success: false };
    }
  },

  publish: id => async dispatch => {
    dispatch({ type: types.PUBLISH_ADVERTISEMENT });
    try {
      const details = await dispatch(actions.getDetails(id));
      if (!details.success) {
        dispatch({ type: types.PUBLISH_ADVERTISEMENT_FAILURE });
        return details;
      }
      if (!details.data.mainImageUrl) {
        dispatch({ type: types.PUBLISH_ADVERTISEMENT_FAILURE });
        dispatch(notifications.showError('Przed publikacją reklamy należy dodać obraz główny.'));
        return { success: false };
      }
      const response = await api.publish(id);
      if (!response.ok || (response.data && response.data.success === false)) {
        dispatch({ type: types.PUBLISH_ADVERTISEMENT_FAILURE });
        dispatch(notifications.showError('Wystąpił problem podczas publikowania reklamy'));
        logger.error(response.data);
        return { success: false };
      }
      dispatch({ type: types.PUBLISH_ADVERTISEMENT_SUCCESS, data: response.data });
      dispatch(notifications.showSuccess('Opublikowano reklamę'));
      return { success: true, data: response.data };
    } catch (error) {
      dispatch({ type: types.PUBLISH_ADVERTISEMENT_FAILURE });
      dispatch(notifications.showError('Wystąpił problem podczas publikowania reklamy'));
      logger.error(error);
      return { success: false };
    }
  },

  delete: id => async dispatch => {
    dispatch({ type: types.DELETE_ADVERTISEMENT });
    try {
      const response = await api.delete(id);
      if (!response.ok || (response.data && response.data.success === false)) {
        dispatch({ type: types.DELETE_ADVERTISEMENT_FAILURE });
        dispatch(notifications.showError('Wystąpił problem podczas usuwania reklamy'));
        logger.error(response.data);
        return { success: false };
      }
      dispatch({ type: types.DELETE_ADVERTISEMENT_SUCCESS, data: response.data });
      dispatch(notifications.showSuccess('Usunięto reklamę'));
      return { success: true, data: response.data };
    } catch (error) {
      dispatch({ type: types.DELETE_ADVERTISEMENT_FAILURE });
      dispatch(notifications.showError('Wystąpił problem podczas usuwania reklamy'));
      logger.error(error);
      return { success: false };
    }
  },
};
